import { render } from "./assign_questions_to_enquiry_form.html?vue&type=template&id=2452cee2&external"
import script from "./assign_questions_to_enquiry_form.js?vue&type=script&lang=js&external"
export * from "./assign_questions_to_enquiry_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__